import React from 'react';
import { GoogleLogin } from '@react-oauth/google';

const GoogleLoginButton = ({ onSuccess, onError, loading }) => {
  return (
    <div className="google-login-wrapper">
      <GoogleLogin
        onSuccess={credentialResponse => {
          if (credentialResponse.credential) {
            onSuccess(credentialResponse.credential);
          } else {
            onError(new Error('No credential received'));
          }
        }}
        onError={onError}
        useOneTap={false}
        auto_select={false}
        theme="filled_blue"
        size="large"
        text="signin_with"
        shape="rectangular"
        locale="pt"
        disabled={loading}
      />
      {loading && (
        <div className="login-loading">
          <div className="spinner"></div>
          <span>A verificar credenciais...</span>
        </div>
      )}
    </div>
  );
};

export default GoogleLoginButton;
